import { Controller } from "@hotwired/stimulus"

// Lowercases a text field as it's typed, keeping the caret where it was.
// RapidRails' inputs have no way to do this.
export default class extends Controller {
  apply(event) {
    const field = event.target
    const lower = field.value.toLowerCase()
    if (lower === field.value) return

    const { selectionStart, selectionEnd } = field
    field.value = lower
    field.setSelectionRange(selectionStart, selectionEnd)
  }
}
